import PropTypes from 'prop-types';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import styled from 'styled-components';

const ImageViewer = ({ className, url }: { className?: string; url: string }) => {
  return (
    <StyledTransformWrapper>
      <TransformComponent wrapperStyle={{ width: '100%', height: '100%' }} contentStyle={{ width: '100%', height: '100%' }}>
        <StyledImg
          className={className}
          alt="file"
          src={url}
          loading="lazy" // only download when near viewport
          decoding="async" // don't block rendering
        />
      </TransformComponent>
    </StyledTransformWrapper>
  );
};

// Add a wrapper to ensure the zoom container fills its parent
const StyledTransformWrapper = styled(TransformWrapper)`
  width: 100%;
  height: 100%;
  overflow: hidden; /* Hide scrollbars potentially added by wrapper */
`;

const StyledImg = styled.img`
  && {
    display: block;
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
  }
`;

ImageViewer.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string.isRequired,
};

ImageViewer.defaultProps = {
  className: undefined,
};

export { ImageViewer };
